import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-12 px-4" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="text-center mb-8" data-id="element-36">
          <h3 className="font-heading font-bold text-2xl mb-4" data-id="element-37">
            🧶 MÉTODO CREA CON HILOS
          </h3>
          <p className="font-body text-gray-400" data-id="element-38">
            Aprende crochet desde cero y crea piezas hermosas
          </p>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center" data-id="element-39">
          <p className="font-body text-sm text-gray-400" data-id="element-40">
            © {new Date().getFullYear()} Método Crea con Hilos. Todos los
            derechos reservados.
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-6 text-sm" data-id="element-41">
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-42">
              Términos y Condiciones
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-43">
              Política de Privacidad
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-44">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}